import { type ChangeEvent } from 'react';
import {
	TextField,
	type TextFieldProps,
	Typography,
	makeStyles,
} from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
	buttonContainer: {
		alignItems: 'center',
		display: 'flex',
	},
	filter: {
		fontSize: 14,
		fontWeight: 500,
	},
	input: {
		fontWeight: 500,
		padding: 0,
	},
	select: {
		marginLeft: 8,
	},
}));

interface IProps {
	value: string | number;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	children: any;
	handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
	label?: string;
}

export function SelectFilter({
	children,
	handleChange,
	label,
	style,
	value,
	...rest
}: IProps & TextFieldProps) {
	const classes = useStyles();

	return (
		<div
			className={clsx(
				classes.buttonContainer,
				rest?.className ? rest?.className : '',
			)}
			style={style}
		>
			<Typography className={classes.filter}> {label}: </Typography>

			{
				// @ts-ignore
				<TextField
					InputProps={{
						classes: {
							input: classes.input,
						},
						disableUnderline: true,
					}}
					SelectProps={{
						displayEmpty: true,
					}}
					className={classes.select}
					onChange={handleChange}
					select
					size={'small'}
					value={value}
					{...rest}
				>
					{children}
				</TextField>
			}
		</div>
	);
}
